import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { supabase } from "../supabaseClient";
import { Button, Dropdown, Form, Input } from "semantic-ui-react";

const CustomerForm = ({ setActiveIndex }) => {
  const [state, setState] = useState(false);
  const query = new URLSearchParams(useLocation().search);

  const [form, setForm] = useState({
    fullName: query.get("fullName") || "",
    email: query.get("email") || "",
    country: query.get("country") || "",
    type: query.get("type") || "",
    interested: [],
  });

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleForm = async () => {
    setState(true);
    try {
      const { data, error } = await supabase.from("beta-customer").insert([
        {
          fullName: form.name,
          email: form.email,
          country: form.country,
          type: form.type,
          interested: form.interested,
        },
      ]);

      if (data) {
        setState(false);
        setForm({ fullName: "", email: "", type: "", interested: [] });
        // await supabase
        //   .from("emailLeads_customer")
        //   .update({ isBetaRegistered: "true" })
        //   .eq("email", form.email);
        alert("Submitted Successfully");
        setActiveIndex(1);
      }
      if (error) throw error;
    } catch (e) {
      alert(e.message);
      setState(false);
    }
  };

  useEffect(() => {
    if (query.get("email")) {
      setTimeout(() => handleForm(), 1500);
    }
  }, []);

 
  const countryOptions = [
    { key: "India", value: "India", text: "India" },
    { key: "USA", value: "USA", text: "USA" },
    { key: "Canada", value: "Canada", text: "Canada" },
  ];

  const typeOptions = [
    { key: "Professional", value: "Professional", text: "Professional" },
    {
      key: "Investor/Trader",
      value: "Investor/Trader",
      text: "Investor/Trader",
    },
    {
      key: "Charted Accountant",
      value: "Charted Accountant",
      text: "Charted Accountant",
    },
    { key: "CPA", value: "CPA", text: "CPA" },
    { key: "Auditor", value: "Auditor", text: "Auditor" },
    { key: "Fund Manager", value: "Fund Manager", text: "Fund Manager" },
    {
      key: "Corporate/Enterprise",
      value: "Corporate/Enterprise",
      text: "Corporate/Enterprise",
    },
    { key: "Other", value: "Other", text: "Other" },
  ];

  const interestedOptions = [
    { key: "Tax Calculator", value: "Tax Calculator", text: "Tax Calculator" },
    {
      key: "Taxation Solution",
      value: "Taxation Solution",
      text: "Taxation Solution",
    },
    {
      key: "Profession Solution",
      value: "Profession Solution",
      text: "Profession Solution",
    },
    {
      key: "Catax Enterprise",
      value: "Catax Enterprise",
      text: "Catax Enterprise",
    },
    { key: "Affiliate Program", value: "Affiliate Program", text: "Affiliate Program" },
    {
      key: "Catax Analytics",
      value: "Catax Analytics",
      text: "Catax Analytics",
    },
  ];

  const handleSubmit=()=>{
    if (
        form.fullName === "" ||
        form.email === "" ||
        form.country === "" ||
        form.interested.length === 0 ||
        form.type === ""
      ) {
        alert("Please fill all the fields!");
        return;
      }
      handleForm();
  }

  return (
    <>
      <div
        style={{
          fontSize: 20,
          fontWeight: 500,
          marginTop: 20,
          marginBottom: 30,
          lineHeight: 1.5,
          textAlign: "left",
        }}
      >
        Catax offers the first free crypto tax service for crypto investors. Catax pivots the crypto space by making crypto taxation simple, effective, and easier to implement than current solutions.
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          textAlign: "left",
          maxWidth: 1000,
        }}
      >
        <div style={{ maxWidth: 450 }}>

          <Form>
            <Form.Field>
              <label style={{color:"#a64d79"}}>Full Name</label>
              <Input
                type="text"
                fluid
                style={{ width: "100%" }}
                onChange={onChange}
                name="fullName"
              />
            </Form.Field>
            <Form.Field>
              <label style={{color:"#a64d79"}}>Email</label>
              <Input type="email" fluid onChange={onChange} name="email" />
            </Form.Field>
            <Form.Field>
              <label style={{color:"#a64d79"}}>Country</label>

              <Dropdown
                placeholder="Select Country"
                fluid
                selection
                options={countryOptions}
                onChange={(e, { value }) =>
                  setForm({ ...form, country: value })
                }
                name="country"
                style={{ maxWidth: 350 }}
              />
            </Form.Field>
            <Form.Field>
              <label style={{color:"#a64d79"}}>I am</label>

              <Dropdown
                placeholder="Select One"
                fluid
                selection
                options={typeOptions}
                onChange={(e, { value }) => setForm({ ...form, type: value })}
                style={{ maxWidth: 350 }}
              />
            </Form.Field>
            <Form.Field>
              <label style={{color:"#a64d79"}}>Interested in</label>

              <Dropdown
                placeholder="Select Multiple"
                fluid
                multiple
                selection
                options={interestedOptions}
                onChange={(e, { value }) =>
                  setForm({...form, interested: value })
                }
                style={{ maxWidth: 350 }}
              />
            </Form.Field>
            <Button
              style={{
                outline: 0,
                border: 0,
                background: "#a64d79",
                width: 200,
                padding: 10,
                color: "#fff",
                fontSize: 18,
                marginTop: 40,
                borderRadius: "3px",
              }}
              onClick={handleSubmit}
              loading={state}
            >
              Submit
            </Button>
          </Form>
        </div>
        <div style={{ maxWidth: 400 }}>
          <div style={{ fontWeight: 700, fontSize: 20, marginBottom: 10 }}>
            Need help?
          </div>
          <span style={{ fontSize: 18, lineHeight: 1.6 }}>
          As you are investing in cryptocurrencies, the cryptocurrency tax team at catax is eager to support you. Let's talk!
          </span>

         
        </div>
      </div>
    </>
  );
};

export default CustomerForm;
                                                                                                                                                                                                                                                                                                                                                                               